import * as ng from 'angular';
import {UISelectService} from '../../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../../services/archismall.service';
import {Object} from 'es6-shim';
import {diff} from 'deep-object-diff';
import {IListini, IProfile} from '../../../../../commons/interfaces/listini';
import {IUser} from '../../../../../commons/interfaces/user/user';

// stessa Classe enum da archivist.archismall.util.enums per i tipi di limite
const Limit = {
  FE: 'FE',
  CE: 'CE',
  PEC: 'PEC',

};

class GestioneListinoController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$stateParams',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: {
      user: IUser,
      listino: IListini,
      [key: string]: any
    },
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $stateParams: ng.ui.IStateParamsService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService
  ) {
    $scope.pageHeader = 'Gestione Listino';
    $rootScope.formsubmitted = false;
    $scope.pageSubHeader = '';
    $scope.limitFilter = $stateParams.limit;

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.getListino = () => {
      ArchiSmallServices.getListino(store.get('idListino')).then(response => {
        $scope.listino = JSON.parse(JSON.stringify(response)) as IListini;
        if ($scope.listino.profileList === undefined) {
          $scope.listino.profileList = [];
        }
        $scope.pageSubHeader = `${$scope.listino.name} - ${$scope.listino.code}`;
      });

    };
    $scope.getListino();

    $scope.remove = (item: IProfile) => {
      const index = $scope.listino.profileList.indexOf(item);
      $scope.listino.profileList.splice(index, 1);
      $scope.openConfermaModal();
    };

    $scope.copy = (item: IProfile) => {
      let CopiaModal = $uibModal.open({
        animation: true,
        component: 'copiaProfiloModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          listino: () => {
            return $scope.listino;
          },
          profilo: () => {
            return item;
          }
        }
      });
    };

    $scope.edit = (item: IProfile) => {
      let EditModal = $uibModal.open({
        animation: true,
        component: 'editProfiloModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          listino: () => {
            return $scope.listino;
          },
          profilo: () => {
            return item;
          }
        }
      });
      EditModal.result.then(res => {
        $scope.getListino();
      });
    };

    $scope.openConfermaModal = (size) => {

      // fare modal per conferma o altro vedi poi
      let ConfermaModal = $uibModal.open({
        animation: true,
        component: 'listiniComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          update: true,
          listino: () => {
            return $scope.listino;
          },
        }
      });
      setTimeout($scope.getListino, 3000);
    };

    $scope.creaProfilo = () => {
      $state.go('home.crea-profilo', {limit: $scope.limitFilter});
    };

  }
}

export const GestioneListinoComponent: ng.IComponentOptions = {
  template: require('./gestione-listino.html'),
  controller: GestioneListinoController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-profili/gestione-listino/gestione-listino.ts